import React, { useState, useEffect } from 'react'
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from 'react-native'
import { CommonActions } from '@react-navigation/native'
import { KeyboardAwareScrollView } from '../Components'

import client, { useClient } from '@sart/client'
import { adaptive, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import { guessCardType, maskCardNumber, formatCurrencyToString, testID } from '@sart/utilities'

import {
  Space,
  Description,
  CreditCardForm,
  RadioExtended,
  Text,
  Button,
  StoredPaymentMethod
} from '@sart/components'

import {
  CashIcon,
  Visa,
  MasterCard,
  AmericanExpress,
  ApplePay,
  GooglePay
} from '@sart/icons'

import * as theme from '../Sign/signTheme'

export default function CheckoutPayment(props) {
  const { navigation, route } = props

  const content = useContent()

  const from = route.params?.from
  const requireStoring = route.params?.requireStoring
  
  const {
    cache: {
      basket,
      storedPayment,
      cachedPayment,
			language
    }
  } = useClient()
  const hasRechargeProduct = getHasRechargeProduct()
  const hasRecurringProduct = getHasRecurringProduct()
  
  const [{ loading, error }, setData] = useState({ loading: false, error:'' })
  const [optionSelected, setOptionSelected] = useState(storedPayment ? 'storedCreditCard' : 'creditCard')
  const [cardProduct, setCardProduct] = useState({})
  
  const prepaid = true
  const postpaid = false

  useEffect(() => void fetchCardTokenisationProduct(),[])
  
  async function fetchCardTokenisationProduct() {
    setData({ loading: true })
    try {
      var tokenisationProducts = await client.callApi('catalog','getTokenizeCardProducts',[client.cache.catalogId])
      setCardProduct(tokenisationProducts[0])
      setData({ loading: false })
    } catch (error) {
      setData({ loading: false, error })
    }
  }

  function getHasRecurringProduct() {
    if (basket === undefined){
      return false
    }
    var hasRecurringProduct = false
    for(const basketItem of basket.serviceItems) {
      if(basketItem.recurring === true) {
        return true
      }
    }
    return hasRecurringProduct
  }

  function getHasRechargeProduct() {
    if (basket === undefined){
      return false
    }
    var hasRechargeProduct = false
    for(const basketItem of basket.serviceItems) {
      if(basketItem.category === 'Recharge') {
        hasRechargeProduct = true
      }
    }
    return hasRechargeProduct
  }

  function handleBillMethod(method) {
    var paymentMethod = {
      method: 'bill',
      type: 'sim',
      preview: content.methods.bill
    }
    client.setCachedPayment(paymentMethod)
    navigation.dispatch(
      CommonActions.navigate({
        name:from,
        key:from,
        params:{
          paymentMethod
        }
      })
    )
    navigation.navigate(from,{ paymentMethod })
  }

  function handleBalanceMethod(method) {
    const previewWithBalance = (() => {
      try {
        const balance = client.cache.balances.monetary.quantity

        return `${content.methods.balance} (${formatCurrencyToString(balance)})`
      } catch (error) {
        return content.methods.balance
      }
    })()

    var paymentMethod = {
      method: 'balance',
      type: 'sim',
      preview: previewWithBalance
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  function handleCashMethod(method) {
    const paymentMethod = {
      method: 'cash',
      type: 'cash',
      preview: content.methods.cash
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  function handleStoredCreditCard(method) {
    const paymentMethod = {
      method: 'storedDetails',
      type: storedPayment.type,
      preview: maskCardNumber('111111111111' + storedPayment.tokenizedCards[0].last4Digits)
    }
    navigation.navigate(from, { paymentMethod })
  }
    
  async function handleCardMethod(values, form) {
    const paymentMethod = {
      method: 'creditCard',
      type: guessCardType('0000000000000000'),
      preview: maskCardNumber('****************')
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  function handleApplePayMethod() {
    const paymentMethod = {
      method: 'applePay',
      type: 'applePay',
      preview: content.payment_method.applePay
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  function handleGooglePayMethod() {
    const paymentMethod = {
      method: 'googlePay',
      type: 'googlePay',
      preview: content.payment_method.googlePay
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  function selectedOption(option) {
    setOptionSelected(option)
  }

  function handleBalanceMethod() {
    const paymentMethod = {
      method: 'balance',
      type: 'balance',
      preview: content.payment_method.googlePay
    }
    client.setCachedPayment(paymentMethod)
    navigation.navigate(from, { paymentMethod })
  }

  return (
    <KeyboardAwareScrollView style={styles.container}>
      <View style={styles.wrapper}>

      <Space height={24} />

      {client.isPostpaid && (
        <TouchableOpacity style={styles.section} onPress={() => selectedOption('bill')} >
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.bill}
              selected={optionSelected === 'bill'}
              radioLabelStyle={optionSelected === 'bill' ? styles.labelStyle : {}}
            />
          </View>

          <Space height={12} />

          <Text>{content.payment_method.billInstructions}</Text>
        </TouchableOpacity>
      )}

      {/* {optionSelected === 'bill' &&
        <>
          <Button
            style={styles.button}
            title="Submit"
            titleStyle={{...typography.extrabold, fontSize: 18}}
          />
          <Space height={24} />
        </>
      } */}

      {client.isPrepaid && !hasRechargeProduct && (
        <TouchableOpacity style={styles.section} onPress={() => selectedOption('balance')} {...testID('BalanceOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.balance}
              selected={optionSelected === 'balance'}
              radioLabelStyle={optionSelected === 'balance' ? styles.labelStyle : {}}
            />
          </View>

          <Space height={12} />

          <Text>{content.payment_method.balanceInstructions}</Text>
        </TouchableOpacity>
      )}

{/* 
      {optionSelected === 'balance' &&
        <>
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleBalanceMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45,
            }}
            {...testID('BalanceOptionButton')}
          />
          <Space height={24} />
        </>
      } */}

      {storedPayment &&
        <>
          <TouchableOpacity style={styles.section} onPress={() => selectedOption('storedCreditCard')} {...testID('StoredCardOption')}>
            <View style={{ flexDirection: 'column' }}>
              <RadioExtended
                // style={{ marginRight: "5%" }}
                selected={optionSelected === 'storedCreditCard'}
                label={content.storedPayment.storedCard}
                radioLabelStyle={optionSelected === 'storedCreditCard' ? styles.labelStyle : {}}
              />
              <Space height={4} />

              <Text>{content.payment_method.storedPaymentInstructions}</Text>
              </View>

          </TouchableOpacity>
        </>
      }

        {optionSelected === 'storedCreditCard' &&
          <>
            <StoredPaymentMethod
              disabled={false}
              payment={storedPayment}
              containerStyle={styles.storedPaymentContainer}
              style={styles.inputStyle}
              footerStyle={styles.footerStyle}
							language={language}
							injectedContent={content}
            />
            <Space height={12} />
            <Button
              style={styles.button}
              title={content.common.submit}
              onPress={handleStoredCreditCard}
              titleStyle={{ ...typography.extrabold, fontSize: 18 }}
              {...testID('StoredCardOptionButton')}
            />
          </>
        }

      <Space height={24} />

      <TouchableOpacity style={styles.section} onPress={() => selectedOption('creditCard')} {...testID('CardOption')}>
        <View style={{flexDirection: 'row'}}>
          <RadioExtended
            label={content.payment_method.creditCard}
            selected={optionSelected === 'creditCard'}
            radioLabelStyle={optionSelected === 'creditCard' ? styles.labelStyle : {}}
          />

          <Space flex />

          <Visa />
          <Space width={8} />
          <MasterCard />
          <Space width={8} />
          <AmericanExpress />
        </View>

        <Space height={12} />

        <Text>{content.payment_method.creditCardInstructions}</Text>
      </TouchableOpacity>
      <Space height={12} />
      {optionSelected === 'creditCard' &&
        <>
          <CreditCardForm
            onCardSubmit={handleCardMethod}
            switchStyle={styles.switchStyle}
            // disabledStoring={product && !product.recurring}
            {
              ...((hasRecurringProduct) || requireStoring ? {
                disableToggleStoring: true,
                initialValues: {
                  store: true
                }
              }: {})
            }
            style={styles.creditCardFormInput}
            disabledStyle={styles.disabled}
            enabledStyle={styles.enabled}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...theme.textInputWhiteBackground}
          />
        </>
      }
      <Space height={12} />

      {!hasRecurringProduct && (
        <TouchableOpacity onPress={() => selectedOption('cash')} {...testID('CashOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.cash}
              selected={optionSelected === 'cash'}
              radioLabelStyle={optionSelected === 'cash' ? styles.labelStyle : {}}
            />
            <Space flex/>
            <CashIcon color={colors.srDarkGreen}/>
          </View>

          <Space height={12} />

          <Text>{content.payment_method.cashInstructions}</Text>
        </TouchableOpacity>
      )}

      {optionSelected === 'cash' &&
        <>
          <Space height={24} />
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleCashMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('CashOptionButton')}
            />
        </>
      }
      <Space height={12} />

      {Platform.OS === "ios" && (
        <TouchableOpacity onPress={() => selectedOption('applePay')} {...testID('ApplePayOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.applePay}
              selected={optionSelected === 'applePay'}
              radioLabelStyle={optionSelected === 'applePay' ? styles.labelStyle : {}}
            />
            <Space flex/>
            <ApplePay />
          </View>

          <Space height={12} />

          <Text>{content.payment_method.applePayInstructions}</Text>
        </TouchableOpacity>
      )}

      {optionSelected === 'applePay' &&
        <>
          <Space height={24} />
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleApplePayMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('ApplePayOptionButton')}
            />
        </>
      }

      <Space height={12} />

      {Platform.OS === "android" && (
        <TouchableOpacity onPress={() => selectedOption('googlePay')} {...testID('GooglePayOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.googlePay}
              selected={optionSelected === 'googlePay'}
              radioLabelStyle={optionSelected === 'googlePay' ? styles.labelStyle : {}}
            />
            <Space flex/>
            <GooglePay />
          </View>

          <Space height={12} />

          <Text>{content.payment_method.googlePayInstructions}</Text>
        </TouchableOpacity>
      )}

      {optionSelected === 'googlePay' &&
        <>
          <Space height={24} />
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleGooglePayMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('GooglePayOptionButton')}
            />
        </>
      }
      </View>

      {prepaid === true && (
        <TouchableOpacity onPress={() => selectedOption('balance')} {...testID('PrepaidBalanceOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={content.payment_method.balance}
              selected={optionSelected === 'balance'}
              radioLabelStyle={optionSelected === 'balance' ? styles.labelStyle : {}}
            />
            <Space flex/>
            <GooglePay />
          </View>

          <Space height={12} />

          <Text>{content.payment_method.balanceInstructions}</Text>
        </TouchableOpacity>
      )}

      {optionSelected === 'balance' &&
        <>
          <Space height={24} />
          <Button
            style={styles.topUpButton}
            title={content.navigation.topUp}
            onPress={() => navigation.navigate('TopUp')}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('PrepaidBalanceOptionTopUp')}
            />
          
            <Space height={8} />
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleBalanceMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('PrepaidBalanceOptionButton')}
            />
        </>
      }

      {postpaid === true && (
        <TouchableOpacity onPress={() => selectedOption('bill')} {...testID('BillOption')}>
          <View style={{flexDirection: 'row'}}>
            <RadioExtended
              label={"Pay on Invoice"}
              selected={optionSelected === 'bill'}
              radioLabelStyle={optionSelected === 'bill' ? styles.labelStyle : {}}
            />
            <Space flex/>
          </View>

          <Space height={12} />

          <Text>{content.payment_method.balanceInstructions}</Text>
        </TouchableOpacity>
      )}

      {optionSelected === 'bill' &&
        <> 
          <Space height={24} />
          <Button
            style={styles.button}
            title={content.common.submit}
            onPress={handleBillMethod}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
            {...testID('BillOptionButton')}
            />
        </>
      }
    </KeyboardAwareScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
		backgroundColor:colors.white,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    paddingBottom: 24
  },
  description: {
    textAlign: 'center'
  },
  enabled: {
    backgroundColor: colors.srDarkGreen
  },
  disabled: {
    backgroundColor: colors.white,
    borderColor: colors.srDarkGreen,
    borderWidth: 1
  },
  button: {
    backgroundColor: colors.srDarkGreen
  },
  topUpButton: {
    backgroundColor: colors.srGreen
  },
  buttonTitle: {
    ...typography.lightbold
  },
  creditCardFormInput: {
    ...typography.demi
  },
  section: {
    // paddingTop: 24,
    // paddingBottom: 24
  },
  storedPaymentLabelStyle: {
    ...typography.book,
    color: colors.feature,
    fontSize: 14
  },
  switchStyle: {
    ...typography.demi
  },
  storedPaymentContainer: {
    backgroundColor: colors.white,
    borderColor: colors.srGreen,
    borderWidth: 1
  },
  inputStyle: {
    ...typography.book,
    paddingRight: 20,
  },
  footerStyle: {
    fontSize: 15,
    color: colors.common,
    marginTop: 8,
    ...typography.medium
  },
  labelStyle: {
    color: colors.srDarkGreen
  }
})